import { api } from './http'

export type ChatMuteResult = {
  muted: boolean
  username: string
  changed: boolean
}

/** Usernames this account has muted. */
export function fetchChatMutes(token: string): Promise<{ mutes: string[] }> {
  return api<{ mutes: string[] }>('/account/mutes', { token })
}

/**
 * Mute or unmute one duelist for the signed-in account only.
 */
export function postChatMute(
  token: string,
  username: string,
  muted: boolean,
): Promise<ChatMuteResult> {
  return api<ChatMuteResult>('/account/mutes', {
    method: 'POST',
    token,
    body: JSON.stringify({ username, muted }),
  })
}
